import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "el",
  class: "emh-region-picker",
  dir: "ltr"
}
const _hoisted_2 = ["^open"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_region_picker_popup_component = _resolveComponent("region-picker-popup-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("owc-header-button", {
      "aria-label": "region-picker",
      type: "button",
      "^icon": 'location',
      "^open": _ctx.isVisible,
      "data-test-id": "header-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleRegionPicker && _ctx.toggleRegionPicker(...args)))
    }, null, 8, _hoisted_2),
    _createVNode(_component_region_picker_popup_component, {
      region: _ctx.region,
      "is-visible": _ctx.isVisible,
      "is-required": _ctx.isRequired,
      "regex-validation": _ctx.config?.regex,
      "digit-amount": _ctx.config?.digitsCap,
      "data-test-id": "region-picker-popup",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleRegionPicker(false))),
      onRegionSelected: _ctx.setRegion
    }, null, 8, ["region", "is-visible", "is-required", "regex-validation", "digit-amount", "onRegionSelected"])
  ], 512))
}